import React from "react";
import Button from "../../Button";
import Overlay from "../../Overlay";
import HeaderOverlay from "../../Project/Header";
import Title from "../../Project/Title";

function LinkingConfirmClose({ open, id, handleClose, data }) {
  const handleCloseFunc = (id) => {
    handleClose(id);
  };

  const handleContinue = () => {
    handleClose(id);
    data.continue();
  };

  return (
    <Overlay show={open} closable={true} onClick={handleCloseFunc}>
      <HeaderOverlay showlogo>
        <Title
          isDelete
          projectTitle={
            <div style={{ width: "100%" }}>
              Vous voulez vraiment quitter le mode de liaison ?
            </div>
          }
          subTitle={`Quitter le mode de liaison`}
        />
        <div className="verify-inputs-popup">
          <Button
            text={"Non"}
            onClick={handleContinue}
            className={"action-button"}
            style={{ width: "200px" }}
          />
          <Button
            text={"Oui"}
            onClick={() => handleCloseFunc(id)}
            className={"action-button agree-action-button"}
            iconClassName={"delete-icon"}
            style={{ width: "200px" }}
          />
        </div>
      </HeaderOverlay>
    </Overlay>
  );
}

export default LinkingConfirmClose;
